/* eslint eslint-comments/no-use: off */
/* eslint-disable github/unescaped-html-literal */

import {parseHTML} from '@github-ui/parse-html'
import type {SelectedServer} from './types'

export function escapeHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function createServersEmptyState(): DocumentFragment {
  return parseHTML(
    document,
    `<div class="Box-row d-flex flex-column flex-items-center text-center width-full tmp-py-4 tmp-px-3">
      <svg class="octicon octicon-mcp color-fg-muted mb-2" viewBox="0 0 24 24" width="24" height="24">
        <path d="M9.795 1.694a4.287 4.287 0 0 1 6.061 0 4.28 4.28 0 0 1 1.181 3.819 4.282 4.282 0 0 1 3.819 1.181 4.287 4.287 0 0 1 0 6.061l-6.793 6.793a.249.249 0 0 0 0 .353l2.617 2.618a.75.75 0 1 1-1.061 1.061l-2.617-2.618a1.75 1.75 0 0 1 0-2.475l6.793-6.793a2.785 2.785 0 1 0-3.939-3.939l-5.9 5.9a.734.734 0 0 1-.249.165.749.749 0 0 1-.812-1.225l5.9-5.901a2.785 2.785 0 1 0-3.939-3.939L2.931 10.68A.75.75 0 1 1 1.87 9.619l7.925-7.925Z"></path>
        <path d="M12.42 4.069a.752.752 0 0 1 1.061 0 .752.752 0 0 1 0 1.061L7.33 11.28a2.788 2.788 0 0 0 0 3.94 2.788 2.788 0 0 0 3.94 0l6.15-6.151a.752.752 0 0 1 1.061 0 .752.752 0 0 1 0 1.061l-6.151 6.15a4.285 4.285 0 1 1-6.06-6.06l6.15-6.151Z"></path>
      </svg>
      <p class="mb-1" style="font-weight: 600;">No servers added</p>
      <p class="color-fg-muted" style="font-size: 12px;">Add MCP servers to this allowlist to control which servers can be used.</p>
    </div>`,
  )
}

export function createServerRow(server: SelectedServer, index: number): DocumentFragment {
  return parseHTML(
    document,
    `<div class="Box-row d-flex flex-justify-between flex-items-center py-2 tmp-px-3" data-test-selector="added-server-row">
      <div class="d-flex flex-items-center gap-2">
        <svg class="octicon octicon-server color-fg-muted" viewBox="0 0 16 16" width="16" height="16">
          <path fill-rule="evenodd" d="M1.75 1A1.75 1.75 0 000 2.75v3.5C0 7.216.784 8 1.75 8h12.5A1.75 1.75 0 0016 6.25v-3.5A1.75 1.75 0 0014.25 1H1.75zm0 1.5a.25.25 0 00-.25.25v3.5c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25v-3.5a.25.25 0 00-.25-.25H1.75zM1.75 9A1.75 1.75 0 000 10.75v3.5c0 .966.784 1.75 1.75 1.75h12.5A1.75 1.75 0 0016 14.25v-3.5A1.75 1.75 0 0014.25 9H1.75zm0 1.5a.25.25 0 00-.25.25v3.5c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25v-3.5a.25.25 0 00-.25-.25H1.75z"></path>
          <circle cx="3.5" cy="5" r="1"></circle>
          <circle cx="3.5" cy="12.5" r="1"></circle>
        </svg>
        <div>
          <span style="font-weight: 600;">${escapeHtml(server.name)}</span>
          <div class="color-fg-muted" style="font-size: 12px;">${escapeHtml(server.url)}</div>
        </div>
      </div>
      <button type="button" class="btn-octicon btn-octicon-danger js-remove-server-from-allowlist" data-server-index="${index}" aria-label="Remove ${escapeHtml(server.name)}">
        <svg class="octicon octicon-trash" viewBox="0 0 16 16" width="16" height="16">
          <path fill-rule="evenodd" d="M11 1.75V3h2.25a.75.75 0 010 1.5H2.75a.75.75 0 010-1.5H5V1.75C5 .784 5.784 0 6.75 0h2.5C10.216 0 11 .784 11 1.75zM6.5 1.75a.25.25 0 01.25-.25h2.5a.25.25 0 01.25.25V3h-3V1.75zM4.496 6.675a.75.75 0 10-1.492.15l.66 6.6A1.75 1.75 0 005.405 15h5.19c.9 0 1.652-.681 1.741-1.576l.66-6.6a.75.75 0 00-1.492-.149l-.66 6.6a.25.25 0 01-.249.225h-5.19a.25.25 0 01-.249-.225l-.66-6.6z"></path>
        </svg>
      </button>
    </div>`,
  )
}

function serverCountHtml(serverCount: number): string {
  if (serverCount === 0) return ''

  const label = serverCount === 1 ? 'server' : 'servers'
  return `<div class="color-fg-muted" style="font-size: 12px; margin-top: 4px;">
      <svg class="octicon octicon-server mr-1" viewBox="0 0 16 16" width="16" height="16"><path fill-rule="evenodd" d="M1.75 1A1.75 1.75 0 000 2.75v3.5C0 7.216.784 8 1.75 8h12.5A1.75 1.75 0 0016 6.25v-3.5A1.75 1.75 0 0014.25 1H1.75zm0 1.5a.25.25 0 00-.25.25v3.5c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25v-3.5a.25.25 0 00-.25-.25H1.75zM1.75 9A1.75 1.75 0 000 10.75v3.5c0 .966.784 1.75 1.75 1.75h12.5A1.75 1.75 0 0016 14.25v-3.5A1.75 1.75 0 0014.25 9H1.75zm0 1.5a.25.25 0 00-.25.25v3.5c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25v-3.5a.25.25 0 00-.25-.25H1.75z"></path><circle cx="3.5" cy="5" r="1"></circle><circle cx="3.5" cy="12.5" r="1"></circle></svg>
      ${serverCount} ${label}
    </div>`
}

// TODO: Implement proper i18n by passing localized strings via data attributes
// from the ERB template instead of hardcoding English strings here.
function formatOrgText(orgNames: string[]): string {
  if (orgNames.length === 0) {
    // eslint-disable-next-line i18n-text/no-en -- TODO: pass localized strings via data attributes from ERB template
    return 'All organizations'
  } else if (orgNames.length === 1) {
    return escapeHtml(orgNames[0]!)
  } else if (orgNames.length === 2) {
    return `${escapeHtml(orgNames[0]!)}, ${escapeHtml(orgNames[1]!)}`
  } else {
    const remaining = orgNames.length - 2
    return `${escapeHtml(orgNames[0]!)}, ${escapeHtml(orgNames[1]!)} + ${remaining} more`
  }
}

export function createAllowlistRow(
  name: string,
  description: string,
  serverCount: number,
  orgNames: string[],
  avatarUrl: string,
  userName: string,
): DocumentFragment {
  return parseHTML(
    document,
    `<li class="Box-row tmp-py-3 tmp-px-3" data-test-selector="mcp-allowlist-row">
      <div class="d-flex flex-row width-full flex-items-center">
        <div class="col-3">
          <span style="font-weight: 600;">${escapeHtml(name)}</span>
          <div class="color-fg-muted" style="font-size: 12px;">${escapeHtml(description)}</div>
          ${serverCountHtml(serverCount)}
        </div>
        <div class="col-3">
          <span class="color-fg-muted">${formatOrgText(orgNames)}</span>
        </div>
        <div class="col-2">
          <span class="color-fg-muted">Just now</span>
        </div>
        <div class="col-3">
          <div class="d-flex flex-items-center">
            <img class="avatar avatar-small" src="${escapeHtml(avatarUrl)}" alt="${escapeHtml(userName)}" width="20" height="20">
            <span class="ml-2">${escapeHtml(userName)}</span>
          </div>
        </div>
        <div class="col-1 d-flex flex-justify-end">
        </div>
      </div>
    </li>`,
  )
}

export function createAllowlistTable(
  name: string,
  description: string,
  serverCount: number,
  orgNames: string[],
  avatarUrl: string,
  userName: string,
): DocumentFragment {
  const tableHeader = parseHTML(
    document,
    `<div class="Box" data-test-selector="mcp-allowlists-table">
      <div class="Box-header py-2 tmp-px-3">
        <div class="d-flex flex-row width-full">
          <div class="col-3">
            <span class="text-bold" style="font-size: 12px;">Name</span>
          </div>
          <div class="col-3">
            <span class="text-bold" style="font-size: 12px;">Assigned to</span>
          </div>
          <div class="col-2">
            <span class="text-bold" style="font-size: 12px;">Last updated</span>
          </div>
          <div class="col-3">
            <span class="text-bold" style="font-size: 12px;">Updated by</span>
          </div>
          <div class="col-1"></div>
        </div>
      </div>
      <ul class="Box-body"></ul>
    </div>`,
  )

  const box = tableHeader.querySelector('[data-test-selector="mcp-allowlists-table"]')!
  const body = box.querySelector('ul.Box-body')
  if (body) {
    body.appendChild(createAllowlistRow(name, description, serverCount, orgNames, avatarUrl, userName))
  }

  return tableHeader
}
